import React from "react";

/**
 * PlatformPageShell — standardizes outer wrapper for all platform admin pages.
 *
 * Wide (default): main operational pages — dashboards, lists, analytics.
 * Narrow: settings / config-style pages with form-heavy content.
 *
 * Aligns padding with tenant AdminPageShell so the muscle-memory is identical
 * for someone flipping between the two consoles.
 */
export function PlatformPageShell({
  children,
  width = "wide",
  className = "",
  as: Tag = "div",
  ...rest
}) {
  const widthCls = width === "narrow" ? "max-w-3xl" : "max-w-[1600px]";
  return (
    <Tag
      className={`p-4 sm:p-6 lg:p-8 ${widthCls} mx-auto ${className}`.trim()}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default PlatformPageShell;
